import React, { Component } from "react";
import { Button, Container } from "@mui/material";
import { Box } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { Card, Divider } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { bugdetList } from "../utils/mockData";
import BudgetCategoryItem from "../components/ui-components/budget-tab/BudgetCategoryItem";
import {
    PieChart,
    Pie,
    Cell,
    Label,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import Grid from "@mui/material/Grid";
import BudgetCategory from "../components/ui-components/budget-tab/BudgetCategory";
import Carousel from 'react-material-ui-carousel';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import LoaderBlock from "../components/ui-components/LoaderBlock";

import { getURLBase, updateParentHeight } from "../utils/helperFns";
import { ThreeWayToggle } from "../components/ui-components/ThreeWayToggle";
import wyzrTheme from "../styles/customTheme";
import axios from "axios";

export class BudgetBreakdown extends Component {
    constructor(props) {
        super(props);
        // this.url = getURLBase(true) + '/budgetBreakdown';
        this.pieDataUrl = getURLBase(true) + '/monthbreakdown';
        this.state = {
            isReady: false,
            //total: 0,
            pageisMoney: true,
            showPercentage: false,
            showBudgetCategory: false,
            budgetData: [],
            currentCategory: null,
            active: "-1",
            monthsPieDataOriginial: {},
            monthsPieData: [],
            blur: false
        };
    }

    currentMonthIndex = 0;

    carouselChange = (now, prev) => {
        this.currentMonthIndex = now;
    }

    componentDidMount() {
        axios.post(this.pieDataUrl, { gid: this.props.gid }).then(
            async (response) => {
                console.log("budget breakdown response - ", response.data.body.pieData);
                var monthspiedataResponse = response.data.body.pieData;
                if (monthspiedataResponse == {}) this.setState({ blur: true });
                var monthspiedataProcessed = this.processData(monthspiedataResponse, this.state.active, true);
                this.currentMonthIndex = monthspiedataProcessed.length - 1;
                //console.log("processed piedata - ", monthspiedata);
                this.setState({
                    monthsPieData: monthspiedataProcessed,
                    monthsPieDataOriginial: monthspiedataResponse,
                    //budgetData: response.data.body.budgetList,
                    tutorial_iframe: response.data.body.tutorial_iframe,
                    isReady: true
                }, () => {
                    console.log("budget breakdown state - ", this.state);
                })
            })
            .catch(err => {
                console.log("budget breakdown api error", err);
            })
    }

    componentDidCatch(error, info) {
        console.log("budget breakdown component - error", error, " info - ", info);
    }

    processData = (originalMonthsArray, unit, running_first_time = false) => {
        var processedResponseArr = [];

        Object.values(originalMonthsArray).forEach((monthItem, monthIndex) => {
            console.log("processData month before processing - ", monthItem);
            var piedata = monthItem.details;

            // if (running_first_time){
            //     piedata.push( {
            //         "name": "Home",
            //         "budget": 200,
            //         "budget_co2": 200,
            //         "spent": 180.0,
            //         "spent_co2": 180,
            //         "spent_pct": 0.03,
            //         "category_id": -1
            //     })
            //     piedata.push( {
            //         "name": "Fuel",
            //         "budget": 295,
            //         "budget_co2": 295,
            //         "spent": 178.0,
            //         "spent_co2": 178,
            //         "spent_pct": 0.03,
            //         "category_id": -1
            //     })
            //     piedata.push( {
            //         "name": "Loan",
            //         "budget": 500,
            //         "budget_co2": 500,
            //         "spent": 450.0,
            //         "spent_co2": 450,
            //         "spent_pct": 0.03,
            //         "category_id": -1
            //     })
            //     piedata.push( {
            //         "name": "Bills",
            //         "budget": 300,
            //         "budget_co2": 300,
            //         "spent": 60.0,
            //         "spent_co2": 60,
            //         "spent_pct": 0.03,
            //         "category_id": -1
            //     })
            //     piedata.push( {
            //         "name": "Mixed",
            //         "budget": 100,
            //         "budget_co2": 100,
            //         "spent": 0,
            //         "spent_co2": 10,
            //         "spent_pct": 0.03,
            //         "category_id": -1
            //     })
            // }


            // sort piedata by spent
            if (unit == "-1" || unit == "0") {
                piedata.sort((a, b) => (a.spent > b.spent ? -1 : 1));
            }
            else {
                piedata.sort((a, b) => (a.budget_co2 > b.budget_co2 ? -1 : 1));
            }

            var totalMonthBudget = 0;
            var totalMonthSpent = 0;
            var totalMonthSpentCo2 = 0;
            //var totalPercentage = 0;

            var otherBudget = 0;
            var otherBudgetCo2 = 0;
            var otherTotalSpent = 0;
            var otherTotalCo2Spent = 0;
            var otherTotalValue = 0;
            var monthPieDataArray = [];

            piedata.forEach(item => {
                item.spent_category_pct = (item.spent / item.budget)
                totalMonthBudget += item.budget;
                totalMonthSpent += item.spent;
                totalMonthSpentCo2 += item.spent_co2;
            });
            //console.log("totals - ", totalMonthBudget, totalMonthSpent, totalMonthSpentCo2);
            //totalPercentage = Math.round(totalSpent/totalBudget);

            //calculate total
            piedata.forEach((item, index) => {

                if (unit == "-1") item.value = item.budget;
                else if (unit == "0") item.value = parseFloat(item.budget / totalMonthBudget).toFixed(2) * 100;
                else item.value = item.budget_co2;

                item.spent_pct = (item.spent / totalMonthSpent)


                if (index < 4) {
                    monthPieDataArray.push(item);
                }
                else {
                    otherBudget += item.budget;
                    otherBudgetCo2 += item.budget_co2;
                    otherTotalSpent += item.spent;
                    otherTotalCo2Spent += item.spent_co2;
                    otherTotalValue += item.value; // data for displaying in pie based on the unit
                }

                //console.log("item value set - ", item.value);
            });

            if (piedata.length > 4) {
                //console.log("other Total value - ", otherTotalValue);
                let others = {
                    budget: parseFloat(otherBudget.toFixed(2)),
                    budget_co2: parseFloat(otherBudgetCo2.toFixed(2)),
                    name: "Others",
                    spent: parseFloat(otherTotalSpent.toFixed(2)),
                    spent_co2: parseFloat(otherTotalCo2Spent.toFixed(2)),
                    spent_pct: (otherTotalSpent / totalMonthSpent),
                    value: Math.round(otherTotalValue * 100) / 100
                }
                monthPieDataArray.push(others)
            }

            this.setState({ totalMonthSpent: totalMonthSpent })

            var processedMonthItem = {
                details: monthPieDataArray,
                mid: monthItem.mid,
                name: monthItem.name,
                total: totalMonthSpent,
                total_coo: totalMonthSpentCo2,
                budgetCategoriesList: monthItem.details
            }
            //console.log("processData month after processing - ", processedMonthItem);
            monthItem = processedMonthItem;
            processedResponseArr.push(processedMonthItem);
        });

        //console.log("new monthArray - ", processedResponseArr);
        return processedResponseArr;
    };

    returnWhenStateReady = () => (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "20vh",
            }}
        >
            <CircularProgress color="success" />
        </Box>
    )

    updateBudgetUnit = (value) => {
        var monthsPieDataResponse = this.state.monthsPieDataOriginial;
        this.setState({ isReady: false }, () => {
            var updatedPieData = this.processData(monthsPieDataResponse, value);

            if (value === "-1") {
                this.setState({ isReady: true, pageisMoney: true, showPercentage: false, active: value, monthsPieData: updatedPieData })
            }
            else if (value === "0") {
                this.setState({ isReady: true, pageisMoney: true, showPercentage: true, active: value, monthsPieData: updatedPieData })

            } else {
                this.setState({ isReady: true, pageisMoney: false, showPercentage: false, active: value, monthsPieData: updatedPieData });
            }
        });
    }

    toggleBudgetCategory = (budgetCategory, monthName) => {
        var show = this.state.showBudgetCategory;
        show = !show
        this.setState({ showBudgetCategory: show, currentCategory: budgetCategory, categoryMonthName: monthName },
            () => {
                updateParentHeight("parent_BudgetBreakdown", "child_BudgetCategory", this.state.showBudgetCategory);
            });
    }

    CenterLabel = ({ viewBox, amount = 0 }) => {
        const { cx, cy } = viewBox;
        return (
            <React.Fragment>
                <text x={cx} y={cy - 10} textAnchor="middle" dominantBaseline="central">
                    <tspan
                        style={{
                            fontWeight: 700,
                            fontSize: "1.6rem",
                            fontFamily: "Nunito Sans",
                        }}
                    >
                        {this.state.pageisMoney ? '£' : null}{Math.round(amount)}{!this.state.pageisMoney ? 'Kg' : null}
                    </tspan>
                    <br />
                </text>
                <text x={cx} y={cy + 20} textAnchor="middle" dominantBaseline="central">
                    <tspan
                        style={{
                            fontWeight: 700,
                            fontSize: "0.9rem",
                            fontFamily: "Nunito Sans",
                            fill: wyzrTheme.palette.grey[500],
                        }}
                    >
                        Spent
                    </tspan>
                </text>
            </React.Fragment>
        );
    };

    COLORS = ["#ee6352", "#23b5d3", "#279af1", "#57a773", "#070600"];

    CustomTooltip = ({ active, payload, label }) => {
        console.log("payload", payload)
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip">
                    <p>
                        <span className="label">
                            {`${payload[0].name} - `}
                        </span>
                        <span className="value">
                            {this.state.pageisMoney && !this.state.showPercentage ? '£' : null}
                            {this.state.showPercentage ? `${parseFloat(payload[0].value / this.state.totalMonthSpent * 100).toFixed(2)}` : `${payload[0].value}`}
                            {!this.state.pageisMoney && !this.state.showPercentage ? 'Kg' : null}
                            {this.state.showPercentage ? '%' : null}
                        </span>
                    </p>
                </div>
            );
        }

        return null;
    };

    /*
        renderCustomizedLabelLine(props){
            let { cx, cy, midAngle, innerRadius, outerRadius, color, startAngle, endAngle } = props;
            const RADIAN = Math.PI / 180;
            const diffAngle = endAngle - startAngle;
            const radius = innerRadius + (outerRadius - innerRadius);
            let path='';
            for(let i=0;i<((360-diffAngle)/15);i++){
              path += `${(cx + (radius+i) * Math.cos(-midAngle * RADIAN))},${(cy + (radius+i*i) * Math.sin(-midAngle * RADIAN))} `
            }
            return (
              <polyline points={path} stroke={color} fill="none" />
            );
          }
    
        renderCustomizedLabel = (c,budgetTotal) => {
            const RADIAN = Math.PI / 180;
            const radius = c.innerRadius + (c.outerRadius - c.innerRadius) * 1.2;
            const x = c.cx + radius * Math.cos(-(c.midAngle) * RADIAN);
            const y = c.cy + radius * Math.sin(-(c.midAngle) * RADIAN);
    
            const fx = x > c.cx ? x : x;
            const fy = y > c.cy ? y + 10 : y - 22;
            return (
                <text x={fx}
                     y={fy}
                     style={{
                                fontSize: "0.9rem",
                                fontWeight: "700",
                                fontFamily: "Nunito Sans",
                            }}
                            className="recharts-text recharts-label"
                            textAnchor={fx > c.cx ? "start" : "end"}
                            dominantBaseline="central"
                     >
                          {this.state.pageisMoney && !this.state.showPercentage ? '£' : null}
                    {this.state.showPercentage ? ((parseInt(c.value) / budgetTotal) * 100).toFixed(2) : Math.round(c.value)} {this.state.showPercentage ? '%' : null}
                     {!this.state.pageisMoney && !this.state.showPercentage ? 'Kg' : null}
                     <tspan
                        x={fx}
                        y={fy + 16}
                        style={{
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            display: "block",
                            fontFamily: "Nunito Sans",
                            padding: "0.6rem 1.6rem",
                            background: "linear-gradient(to right, #5DC68E, #4AAC48)"
                        }}
                    >
                        {c.name}
                    </tspan>
                </text>
            );
        };*/

    renderLegend = props => {
        console.log("legend props - ", props);
        const { payload } = props;
        return (
            <ul className="custom-labels custom-label-horizontal">
                {
                    payload.map((entry, index) => (
                        <li key={`labelitem-${index}`}>
                            <span className="custom-label-icon" style={{ borderRadius: "50%", backgroundColor: entry.color, width: props.iconSize, height: props.iconSize }}
                            ></span>
                            <span className="custom-label-name">
                                {entry.payload.name}{' - '}
                            </span>
                            <span className="custom-label-value">
                                {this.state.pageisMoney && !this.state.showPercentage ? '£' : null}
                                {!this.state.pageisMoney && !this.state.showPercentage ? 'Kg' : null}
                                {this.state.showPercentage ? '%' : null}
                            </span>
                        </li>
                    ))
                }
            </ul>
        );
    }

    render() {
        const WidgetData = () => (
            <Card className={"widgetCard cardShadow" + `${this.state.isReady ? (`${this.state?.budgetData?.length === null ? "blur" : ""}`) : ""}`} id="parent_BudgetBreakdown">

                <Box sx={{ padding: "1rem", position: "absolute", top: 0, right: 0, zIndex: 1 }}>
                    <ThreeWayToggle handleChange={this.updateBudgetUnit} active={this.state.active} />
                </Box>
                <Typography mt={{ xs: 4.8, sm: 0 }} variant="h4" sx={{ fontWeight: 700 }} align="center" mx={"auto"} width="70%" >
                    Budget Breakdown
                </Typography>

                {this.state.isReady ? (
                    <Carousel className={`w-100 ${this.state.blur ? "blur" : ""}`} autoPlay={false} animation="slide"
                        index={this.currentMonthIndex}
                        navButtonsAlwaysVisible={"auto"} cycleNavigation={false}
                        indicators={false}
                        fullHeightHover={false}
                        swipe={false}
                        navButtonsWrapperProps={{
                            style: {
                                top: "5rem"
                            }
                        }}
                        navButtonsProps={{
                            className: "owlNavButton",
                            style: {
                                backgroundColor: 'transparent',
                                color: "#82B879",
                                fontSize: 50,
                            }
                        }}
                        activeIndicatorIconButtonProps={{
                            style: {
                                color: '#82B879'
                            }
                        }}
                        onChange={this.carouselChange}
                        changeOnFirstRender={true}
                        PrevIcon={<ArrowLeftRoundedIcon fontSize="inherit" />}
                        NextIcon={<ArrowRightRoundedIcon fontSize="inherit" />}
                    >
                        {this.state.monthsPieData.map((monthItem, i) => {
                            return (
                                <>
                                    <Typography
                                        variant="subtitle1"
                                        color="text.secondary"
                                        fontWeight="600"
                                        align="center"
                                        gutterBottom
                                    >
                                        {monthItem.name}
                                        <Button sx={{
                                            margin: "0 auto",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginY: "0.5rem",
                                            marginTop: "-0.3rem",
                                            // fontSize: "0.7rem",
                                            padding: "2px"
                                        }}
                                            onClick={() => this.props.setEmbedUrl(this.state.tutorial_iframe)}
                                        >
                                            See how this works <img src="/tutorial-icon.png" style={{ width: "35px", padding: "5px" }} />
                                        </Button>
                                    </Typography>
                                    {this.state.isReady ? (
                                        <CardContent sx={{ padding: 0 }} textAlign="center">

                                            <Grid container justifyContent={"center"} alignItems="center">
                                                <Grid item lg={4} md={5} sm={6} xs={12} display={"flex"} justifyContent={"center"}>
                                                    <Box marginX={"auto"}>
                                                        <ResponsiveContainer width={"100%"} aspect={1} height={220} minWidth="100%">
                                                            <PieChart height="100%" width="100%" >
                                                                <Pie
                                                                    data={monthItem.details}
                                                                    labelLine={false}
                                                                    outerRadius={"90%"}
                                                                    innerRadius={"70%"}
                                                                    isAnimationActive={false}
                                                                    fill="#8884d8"
                                                                    paddingAngle={0}
                                                                    dataKey="spent"
                                                                    verticalAlign="center"
                                                                    startAngle={180}
                                                                    endAngle={-180}
                                                                >
                                                                    <Label
                                                                        content={<this.CenterLabel amount={this.state.active == "-1" || this.state.active == "0" ? monthItem.total : monthItem.total_coo} />}
                                                                        position="center"
                                                                    />
                                                                    {monthItem.details.map((entry, index) => (
                                                                        <Cell fill={this.COLORS[index % this.COLORS.length]} />
                                                                    ))}
                                                                </Pie>
                                                                <Tooltip content={<this.CustomTooltip />} />
                                                            </PieChart>
                                                        </ResponsiveContainer>
                                                    </Box>
                                                </Grid>
                                                <Grid item lg={4} md={5} sm={6} xs={11}>
                                                    <Box>
                                                        <ul className="custom-labels custom-label-horizontal">
                                                            {
                                                                monthItem.details.map((entry, index) => (
                                                                    <li key={`labelitem-${index}`}>
                                                                        <span className="custom-label-icon" style={{ borderRadius: "50%", backgroundColor: this.COLORS[index], width: 10, height: 10 }}
                                                                        ></span>
                                                                        <span className="custom-label-name">
                                                                            {entry.name}{' - '}
                                                                        </span>
                                                                        <span className="custom-label-value">
                                                                            {this.state.pageisMoney && !this.state.showPercentage ? '£' : null}
                                                                            {this.state.showPercentage ? parseFloat(entry.spent_pct * 100).toFixed(2) : null}
                                                                            {this.state.pageisMoney && !this.state.showPercentage ? entry.spent : null}
                                                                            {!this.state.pageisMoney && !this.state.showPercentage ? entry.spent_co2 : null}

                                                                            {!this.state.pageisMoney && !this.state.showPercentage ? 'Kg' : null}
                                                                            {this.state.showPercentage ? '%' : null}
                                                                        </span>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                            <Divider light />
                                            <Grid maxWidth={700} marginX="auto" px={{ xs: 2, md: 0 }}>
                                                {monthItem.budgetCategoriesList.map((el, index) => (
                                                    <BudgetCategoryItem
                                                        key={`budget-${index}`}
                                                        budgetData={el}
                                                        iconImage={`/budgetbreakdown/${el.name}.svg`}//{images[el.name]}
                                                        pageisMoney={this.state.pageisMoney}
                                                        showPercentage={this.state.showPercentage}
                                                        handleBudgetClick={() => this.toggleBudgetCategory(el, monthItem.name)}></BudgetCategoryItem>
                                                ))}
                                            </Grid>

                                        </CardContent>) : null
                                    }
                                </>)
                        })
                        }

                    </Carousel>) : <LoaderBlock />
                }

                {this.state.showBudgetCategory ?
                    <BudgetCategory
                        gid={this.props.gid}
                        categoryId={this.state.currentCategory?.category_id}
                        categoryName={this.state.currentCategory?.name}
                        monthName={this.state.categoryMonthName}
                        unit={this.state.active}
                        toggleHandler={() => this.toggleBudgetCategory(this.state.currentCategory)}
                    ></BudgetCategory> : null}
            </Card>
        );

        return <WidgetData />;
    }
}

export default BudgetBreakdown;